import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { InternationalPhoneInput } from '@/unlayer-tools/unlayer-form-tool/renderer/formFields/InternationalPhoneInput';
import { INTL_PHONE_INPUT_ID } from '@/hosting/ssr/islands';

const componentMap = {
    [INTL_PHONE_INPUT_ID]: InternationalPhoneInput,
};

export default function hydrate(root = document) {
    Object.entries(componentMap).forEach(([id, Component]) => {
        const containers = root.querySelectorAll(`[${id}]`);

        containers.forEach((container) => {
            if (container.dataset.hydrated) return;

            container.dataset.hydrated = 'true';

            const propsScript = container.querySelector('script[data-props]');
            let props;

            if (!propsScript) {
                console.warn(`[hydrate] Missing props script in ${id} container - skipping.`);

                return;
            }

            try {
                props = JSON.parse(propsScript.innerHTML);
            } catch (e) {
                console.error(`[hydrate] Failed to parse props for ${id}:`, e);

                return;
            }

            propsScript.remove();
            hydrateRoot(container, <Component {...props} />);
        });
    });
}
